import KeyValuePair from '@/modules/core/support/KeyValuePair'
import _ from 'lodash'

export class Country {
    public id = 0
    constructor (public code: string, public name: string) {}

    public static convert (data: KeyValuePair): Country {
        const country = new Country(data.code, data.name)
        country.id = data.id

        return country
    }
}

export class AdminDivision {
    public id = 0
    public name = ''
    public country = ''
    public level = -1

    constructor (name: string, country: string, level: number) {
        this.name = name
        this.country = country
        this.level = level
    }

    public static convert (data: KeyValuePair): AdminDivision {
        const adminDivision = new AdminDivision(data.name, data.country, data.level)
        adminDivision.id = data.id

        return adminDivision
    }
}

export class PostalCode {
    [key: string]: any
    public id = -1
    public postalCode = ''
    public placeName = ''
    public country = ''
    public adminLevel1 = new AdminDivision('', '', -1)
    public adminLevel2 = new AdminDivision('', '', -1)
    public adminLevel3 = new AdminDivision('', '', -1)

    public static deserialize (data: KeyValuePair) {
        const postalCode = new this()
        postalCode.id = data.id
        postalCode.postalCode = data.postal_code
        postalCode.placeName = data.place_name
        postalCode.country = data.country
        // tslint:disable-next-line:no-unused-expression
        _.range(1, 3).forEach(level => {
            const ad = data[`admin_division_${level}`]
            if (!ad) {
                return
            }

            postalCode[`adminDivision${level}`] = AdminDivision.convert(ad)
        })

        return postalCode
    }
}
